import { api } from './api';

export interface AdminTeamSummary {
  id: number;
  name: string;
  plan: string;
  ownerId: number;
  ownerEmail: string;
  ownerName: string;
  memberCount: number;
}

export const adminApi = {
  listTeams: () => api.get<AdminTeamSummary[]>('/api/auth/admin/teams'),

  assignTeam: (userId: number, teamId: number, keepOldTeam?: boolean) =>
    api.patch<{ message: string; teamId: number }>(
      `/api/auth/admin/users/${userId}/team`,
      { teamId, keepOldTeam },
    ),

  setTeamRole: (userId: number, role: 'admin' | 'member') =>
    api.patch<{ message: string; role: string }>(
      `/api/auth/admin/users/${userId}/team-role`,
      { role },
    ),
};
